<template>
  <div class="background-wrapper">
    <div class="franchise">
      <div class="wrappContent">
        <div class="hMain">{{ $t("franchise.hMain") }}</div>

        <div class="wrappHero">
          <div class="heroTxt">
            <p class="txt" v-html="$t('franchise.txt1')"></p>
            <p class="title" v-html="$t('franchise.h')"></p>
            <p class="txt" v-html="$t('franchise.txt2')"></p>
            <p class="txt" v-html="$t('franchise.txt3')"></p>
            <p class="txt" v-html="$t('franchise.txt4')"></p>
          </div>
          <div class="hero">
            <img src="../assets/images/franchiseHero.jpg" alt="" />
          </div>
        </div>

        <img
          v-if="showLoader"
          :src="require('@/assets/images/loader.gif')"
          alt=""
          class="spiner-img"
        />
        <!-- table -->
        <table v-else>
          <thead>
            <tr>
              <td></td>
              <td>{{ $t("main.documentName") }}</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(doc, index) in documents" :key="index">
              <td>
                <!-- <div class="icon-wrapper">
                          <img v-if="doc.doc_priority === 2" src="@/assets/icons/importantDocument.png" alt="preview icon">
                        </div> -->
              </td>
              <td>{{ doc.frd_name }}</td>
              <td v-if="doc.frd_type !== 'DOC'" style="width:50px">
                <a
                  class="link"
                  :href="generatePreviewLink(doc)"
                  target="_blank"
                >
                  <div class="icon-wrapper">
                    <img
                      src="@/assets/icons/previewDocument.png"
                      alt="preview icon"
                    />
                  </div>
                </a>
              </td>
              <td v-else></td>
              <td style="width:60px">
                <a class="link" :href="generateDownloadLink(doc)">
                  <div class="icon-wrapper">
                    <img
                      src="@/assets/icons/downloadDocument.png"
                      alt="preview icon"
                    />
                  </div>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- end table -->
      </div>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
export default {
  name: "Franchise",
  data() {
    return {
      documents: [],
      showLoader: false
    };
  },
  mounted() {
    this.getListFranchise();
  },
  activated() {
    this.getListFranchise();
  },
  methods: {
    getListFranchise() {
      this.showLoader = true;
      window.scrollTo({ top: 0, behavior: "smooth" });

      api
        .getListFranchise()
        .then(res => {
          console.log(res);
          this.documents = res.data.data;
          this.showLoader = false;
        })
        .catch(e => {
          this.showLoader = false;
          console.log(e);
        });
    },
    generatePreviewLink(doc) {
      return baseURL + `/franchise/franchise/${doc.frd_id}/document`;
    },
    generateDownloadLink(doc) {
      return baseURL + `/franchise/franchise/${doc.frd_id}/download`;
    }
  },
  watch: {
    // '$i18n.locale': {
    //   handler (newLocale, oldLocale) {
    //     if (newLocale !== oldLocale) {
    //       this.getListFranchise()
    //     }
    //   }
    // }
  }
};
</script>

<style lang="scss">
.background-wrapper {
  background: #f2f2f2;
  width: 100%;
}
.spiner-img {
  width: 150px;
}

.franchise {
  background: #ffffff;
  margin: 20px auto;
  padding: 41px 0;
  position: relative;
  max-width: 1320px;
  width: calc(100% - 40px);

  .wrappContent {
    width: 80%;
    margin: auto;
    .hMain {
      font-style: normal;
      font-weight: 700;
      font-size: 30px;
      line-height: 49px;
      text-transform: uppercase;

      color: #7a384c;
      margin-bottom: 41px;
    }
    .wrappHero {
      display: flex;
      width: 100%;
      justify-content: center;
      // align-items: center;
      margin-bottom: 20px;
      gap: 20px 100px;
    }

    .hero {
      width: 50%;
      padding-top: 14px;
      padding-bottom: 10px;
      img {
        // max-width: 767px;
        width: 100%;
        // aspect-ratio: 15 / 9.2;
      }
    }
    .heroTxt {
      // font-family: Catamaran;
      // padding: 27px;
      width: 80%;
      box-sizing: border-box;
      padding-right: 23px;
      .title {
        color: #7a384c;
        font-weight: 400;
        font-size: 20px;
        line-height: 32.8px;
        text-transform: uppercase;
        text-align: left;
      }
      .txt {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        text-align: left;

        color: #000000;
      }
    }

    table {
      border: 1px solid #e8e8e8;
      width: 100%;
      // max-width: 1020px;
      border-collapse: collapse;

      thead {
        td {
          padding: 5px;
          box-sizing: border-box;
          text-align: left;
          height: 65px;
          border-bottom: 1px solid #e8e8e8;
          font-weight: 800;
          font-size: 15px;
          line-height: 24px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          text-transform: uppercase;
        }
      }
      tbody {
        tr {
          td {
            padding: 5px;
            box-sizing: border-box;
            text-align: left;
            height: 60px;
            border-bottom: 1px solid #e8e8e8;
            font-weight: 600;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: 0.06em;
            color: #606060;

            .icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
        tr:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .franchise {
    background: #ffffff;
    margin: 20px auto;
    padding: 41px 0;
    position: relative;
    max-width: 1320px;
    width: calc(100% - 40px);

    .wrappContent {
      width: 80%;
      margin: auto;
      .hMain {
        font-style: normal;
        font-weight: 700;
        font-size: 30px;
        line-height: 49px;
        text-transform: uppercase;

        color: #7a384c;
        margin-bottom: 41px;
      }
      .wrappHero {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-bottom: 41px;
        flex-direction: column-reverse;
      }

      .hero {
        width: 100%;
        padding-top: 0px;
        img {
          // max-width: 767px;
          width: 100%;
          // aspect-ratio: 15 / 9.2;
        }
      }
      .heroTxt {
        // font-family: Catamaran;
        // padding: 27px;
        width: 100%;
        .title {
          text-align: center;
        }
        .txt {
          text-align: center;
        }
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .franchise {
    background: #ffffff;
    margin: 10px auto;
    padding: 20px 0;
    position: relative;
    max-width: 1320px;
    width: calc(100% - 20px);

    .wrappContent {
      width: 94%;
      .hMain {
        font-style: normal;
        font-weight: 700;
        font-size: 23px;
        line-height: 35px;
        text-transform: uppercase;

        color: #7a384c;
        margin-bottom: 21px;
      }
    }
  }
}
</style>
